/*
 * <emeltec-countdown data-end="unix seconds">: fills its days/hours/minutes/seconds boxes
 * every second and hides itself once the end has passed.
 */
if (!customElements.get('emeltec-countdown')) {
  customElements.define(
    'emeltec-countdown',
    class extends HTMLElement {
      connectedCallback() {
        this.end = Number(this.dataset.end) * 1000;
        this.parts = {};
        this.querySelectorAll('[data-unit]').forEach((el) => (this.parts[el.dataset.unit] = el));
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      tick() {
        const left = Math.floor((this.end - Date.now()) / 1000);
        if (left <= 0) {
          this.hidden = true;
          clearInterval(this.timer);
          return;
        }
        const pad = (n) => String(n).padStart(2, '0');
        this.parts.days.textContent = Math.floor(left / 86400);
        this.parts.hours.textContent = pad(Math.floor((left % 86400) / 3600));
        this.parts.minutes.textContent = pad(Math.floor((left % 3600) / 60));
        this.parts.seconds.textContent = pad(left % 60);
        this.hidden = false;
      }
    }
  );
}
